var map = {
	"./ExceptionManagementCenter.svg": "./src/icons/svg/ExceptionManagementCenter.svg",
	"./Failed.svg": "./src/icons/svg/Failed.svg",
	"./FinancialCenter.svg": "./src/icons/svg/FinancialCenter.svg",
	"./InvoiceCenter.svg": "./src/icons/svg/InvoiceCenter.svg",
	"./QuestionMark.svg": "./src/icons/svg/QuestionMark.svg",
	"./ReportManagement.svg": "./src/icons/svg/ReportManagement.svg",
	"./TechnicalSupportCenter.svg": "./src/icons/svg/TechnicalSupportCenter.svg",
	"./arrowWaveLine.svg": "./src/icons/svg/arrowWaveLine.svg",
	"./basicData.svg": "./src/icons/svg/basicData.svg",
	"./bulkyExpress.svg": "./src/icons/svg/bulkyExpress.svg",
	"./channel.svg": "./src/icons/svg/channel.svg",
	"./chart.svg": "./src/icons/svg/chart.svg",
	"./chengzhong.svg": "./src/icons/svg/chengzhong.svg",
	"./chengzhong2.svg": "./src/icons/svg/chengzhong2.svg",
	"./coins.svg": "./src/icons/svg/coins.svg",
	"./collect.svg": "./src/icons/svg/collect.svg",
	"./dajian.svg": "./src/icons/svg/dajian.svg",
	"./dashboard.svg": "./src/icons/svg/dashboard.svg",
	"./dingdan.svg": "./src/icons/svg/dingdan.svg",
	"./document-issue.svg": "./src/icons/svg/document-issue.svg",
	"./example.svg": "./src/icons/svg/example.svg",
	"./eye-open.svg": "./src/icons/svg/eye-open.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./fenjian.svg": "./src/icons/svg/fenjian.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./gongdan.svg": "./src/icons/svg/gongdan.svg",
	"./gongyingshangguanli.svg": "./src/icons/svg/gongyingshangguanli.svg",
	"./hourglass.svg": "./src/icons/svg/hourglass.svg",
	"./iconEye.svg": "./src/icons/svg/iconEye.svg",
	"./intelligentCabinet.svg": "./src/icons/svg/intelligentCabinet.svg",
	"./kehu.svg": "./src/icons/svg/kehu.svg",
	"./largeScreen.svg": "./src/icons/svg/largeScreen.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./message.svg": "./src/icons/svg/message.svg",
	"./money_bag.svg": "./src/icons/svg/money_bag.svg",
	"./motorcycle.svg": "./src/icons/svg/motorcycle.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./noData.svg": "./src/icons/svg/noData.svg",
	"./orderPackage.svg": "./src/icons/svg/orderPackage.svg",
	"./orderReport.svg": "./src/icons/svg/orderReport.svg",
	"./orders.svg": "./src/icons/svg/orders.svg",
	"./package.svg": "./src/icons/svg/package.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./pathwayState.svg": "./src/icons/svg/pathwayState.svg",
	"./problem.svg": "./src/icons/svg/problem.svg",
	"./product.svg": "./src/icons/svg/product.svg",
	"./returnCenter.svg": "./src/icons/svg/returnCenter.svg",
	"./reverse.svg": "./src/icons/svg/reverse.svg",
	"./ruku.svg": "./src/icons/svg/ruku.svg",
	"./salesService.svg": "./src/icons/svg/salesService.svg",
	"./scan.svg": "./src/icons/svg/scan.svg",
	"./seticon.svg": "./src/icons/svg/seticon.svg",
	"./shouye.svg": "./src/icons/svg/shouye.svg",
	"./sorting.svg": "./src/icons/svg/sorting.svg",
	"./system1.svg": "./src/icons/svg/system1.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./tag.svg": "./src/icons/svg/tag.svg",
	"./tongjibaobiao.svg": "./src/icons/svg/tongjibaobiao.svg",
	"./trajectory.svg": "./src/icons/svg/trajectory.svg",
	"./trajectoryQuery.svg": "./src/icons/svg/trajectoryQuery.svg",
	"./transfer.svg": "./src/icons/svg/transfer.svg",
	"./transport.svg": "./src/icons/svg/transport.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./truck.svg": "./src/icons/svg/truck.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./warehouse.svg": "./src/icons/svg/warehouse.svg",
	"./warehousing.svg": "./src/icons/svg/warehousing.svg",
	"./warehousingBlue.svg": "./src/icons/svg/warehousingBlue.svg",
	"./woven.svg": "./src/icons/svg/woven.svg",
	"./xiaoxi.svg": "./src/icons/svg/xiaoxi.svg",
	"./xitong.svg": "./src/icons/svg/xitong.svg",
	"./yonghu.svg": "./src/icons/svg/yonghu.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";